import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="descargar" className="py-32 px-4 bg-dark-800 relative scroll-mt-8" data-id="element-22">
      <div className="max-w-3xl mx-auto text-center" data-id="element-23">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl font-bold text-white mb-12" data-id="element-24">
          Tu siguiente paso (simple)
        </motion.h2>

        <div className="space-y-6 mb-16 text-left max-w-lg mx-auto" data-id="element-25">
          {['Elige un solo pendiente que estés evitando.', 'Pon un temporizador de 10 minutos.', 'Y cruza las 3 Puertas una vez.'].map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="flex items-center gap-4" data-id="element-26">
              <div className="w-8 h-8 rounded-full bg-amber-900/30 text-amber-500 flex items-center justify-center font-bold border border-amber-500/20" data-id="element-27">
                {index + 1}
              </div>
              <p className="text-xl text-gray-300" data-id="element-28">{step}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} data-id="element-29">
          <p className="text-amber-gold italic mb-10 text-lg" data-id="element-30">
            "No para terminar tu vida. Para empezar tu día."
          </p>

          <div className="bg-dark-900 border border-amber-gold/20 rounded-2xl p-8 md:p-10 max-w-md mx-auto mb-8 shadow-glow-amber" data-id="element-31">
            <p className="text-amber-gold font-bold text-sm tracking-widest uppercase mb-4" data-id="element-32">
              Precio especial de lanzamiento
            </p>
            <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-33">
              <span className="text-gray-500 line-through text-2xl font-medium" data-id="element-34">
                $19.99
              </span>
              <span className="text-5xl md:text-6xl font-black text-white text-glow-amber" data-id="element-35">
                $6.39
              </span>
              <span className="text-gray-400 text-sm" data-id="element-36">USD</span>
            </div>
            <p className="text-amber-gold/70 text-sm mb-8" data-id="element-37">
              Ahorra 68% — oferta por tiempo limitado
            </p>

            <a href="https://www.vidasimple365.com/cart/55238539346088:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="w-full px-10 py-5 bg-amber-500 hover:bg-amber-400 text-dark-900 font-black text-xl rounded-xl transition-all shadow-glow-amber-strong hover:scale-105 flex items-center justify-center gap-3 no-underline" data-id="element-38">
              Descargar El Miedo Diario
              <ArrowRight className="w-6 h-6" data-id="element-39" />
            </a>

            <div className="mt-5 flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-40">
              <Clock size={14} data-id="element-41" />
              <span data-id="element-42">Acceso inmediato · PDF Digital</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}